import { useState } from "react";
import { auth } from "../../firebase/firebase";
import { updatePassword } from "firebase/auth";
import { Link } from "react-router-dom";
import "../../assets/css/admin/changePassword.css";

function ChangePassword() {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const changePassword = async () => {
    if (!password) {
      setMessage("Please enter a new password.");
      return;
    }

    if (password.length < 6) {
      setMessage("Password must be at least 6 characters.");
      return;
    }

    try {
      await updatePassword(auth.currentUser, password);

      setMessage("Password updated successfully!");
      setPassword("");
    } catch (error) {
      setMessage(error.message.replace("Firebase: ", ""));
    }
  };

  return (
    <div className="change-page">
      <div className="change-card">
        <h2>Change Password</h2>

        <p className="subtitle">
          Enter a new password for your account.
        </p>

        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

       <button
    className="change-password-btn"
    onClick={changePassword}
>
    Update Password
</button>

        {message && <p className="message">{message}</p>}

        <p className="bottom-text">
          <Link to="/admin/login">Back to Login</Link>
        </p>
      </div>
    </div>
  );
}

export default ChangePassword;